import { Controller } from "@hotwired/stimulus"

// 인라인 SVG 차트(InlineChartHelper) 위에 마우스를 올리면
// 그 구간의 값을 툴팁으로 보여준다.
//
// SVG 기본 <title> 툴팁은 뜨는 데 1초 이상 걸리고 여러 줄을 읽기 어려워서
// 직접 그린다. 값은 서버에서 tooltips value 로 통째로 내려받는다.
//
// tooltips: [{ label: "2026.08.21", rows: [{ name, value, color }] }, ...]
export default class extends Controller {
  static targets = ["plot", "guide", "tooltip"]
  static values = { tooltips: Array }

  connect() {
    this.hide()
  }

  move(event) {
    const points = this.tooltipsValue
    if (points.length === 0 || !this.hasPlotTarget) return

    const bounds = this.plotTarget.getBoundingClientRect()
    if (bounds.width === 0) return

    const clientX = event.touches ? event.touches[0].clientX : event.clientX
    const ratio = Math.min(Math.max((clientX - bounds.left) / bounds.width, 0), 1)
    const index = Math.round(ratio * (points.length - 1))
    const percent = points.length > 1 ? (index / (points.length - 1)) * 100 : 50

    this.render(points[index])

    if (this.hasGuideTarget) {
      this.guideTarget.style.left = `${percent}%`
      this.guideTarget.classList.remove("hidden")
    }

    if (this.hasTooltipTarget) {
      this.tooltipTarget.classList.remove("hidden")
      // 툴팁이 차트 밖으로 나가지 않게 좌우 끝에서 붙여준다.
      const tooltipWidth = this.tooltipTarget.offsetWidth
      const centered = (percent / 100) * bounds.width - tooltipWidth / 2
      const left = Math.min(Math.max(centered, 0), Math.max(bounds.width - tooltipWidth, 0))
      this.tooltipTarget.style.left = `${left}px`
    }
  }

  hide() {
    if (this.hasGuideTarget) this.guideTarget.classList.add("hidden")
    if (this.hasTooltipTarget) this.tooltipTarget.classList.add("hidden")
  }

  // 폰트명 같은 사용자 입력이 섞이므로 textContent 로만 채운다.
  render(point) {
    if (!this.hasTooltipTarget || !point) return

    this.tooltipTarget.replaceChildren()

    const label = document.createElement("div")
    label.className = "font-medium text-gray-900 dark:text-gray-100"
    label.textContent = point.label
    this.tooltipTarget.appendChild(label)

    point.rows.forEach((row) => {
      const line = document.createElement("div")
      line.className = "flex items-center gap-1.5 whitespace-nowrap"

      if (row.color) {
        const dot = document.createElement("span")
        dot.className = "inline-block h-1.5 w-1.5 rounded-full shrink-0"
        dot.style.backgroundColor = row.color
        line.appendChild(dot)
      }

      const name = document.createElement("span")
      name.className = "text-gray-500 dark:text-gray-400"
      name.textContent = row.name
      line.appendChild(name)

      const value = document.createElement("span")
      value.className = "ml-auto pl-2 text-gray-900 dark:text-gray-100"
      value.textContent = row.value
      line.appendChild(value)

      this.tooltipTarget.appendChild(line)
    })
  }
}
